import PropTypes from 'prop-types';

import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './EntityMenuItem.style';
import { MenuItem } from '../MenuItem';

function EntityMenuItem({ entity, onClick }) {
  const handleClickTracking = useLinkPressedCallback(entity.eventProps);

  const handleClickEntity = () => {
    handleClickTracking();
    onClick();
  };

  return (
    <MenuItem
      onClick={handleClickEntity}
      variant={entity.hasNameReservation ? 'reserved' : ''}
    >
      <Styled.Link
        role="menuitem"
        to={entity.path}
      >
        <Text truncate>{entity.name}</Text>
        {entity.hasNameReservation && (
          <Styled.Pill>
            Reserved
          </Styled.Pill>
        )}
      </Styled.Link>
    </MenuItem>
  );
}

EntityMenuItem.propTypes = {
  entity: PropTypes.shape({
    hasNameReservation: PropTypes.bool.isRequired,
    eventProps: PropTypes.shape({
      dynamicProperties: PropTypes.shape({
        navIndex: PropTypes.number,
        navLevel: PropTypes.number
      }),
      elementName: PropTypes.string,
      appSection: PropTypes.string
    }).isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired
};

export default EntityMenuItem;
